import {Component, inject, Input, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from '../../components/button-padrao/button-padrao.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { CanalModel } from '../../model/canal/canal-model';

@Component({
  selector: 'app-modal-selecionar-canal',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SelectOneComponent
  ],
  templateUrl: './modal-selecionar-canal.component.html',
  styleUrl: './modal-selecionar-canal.component.css'
})
export class ModalSelecionarCanalComponent implements OnInit {

  @Input() canais: CanalModel[] = [];
  canalSelecionado: CanalModel = new CanalModel();

  private readonly dialog = inject<MatDialogRef<ModalSelecionarCanalComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.canais = this.data['canais'];
  }

  encerrar(){
    this.dialog.close(false);
  }

  enviar(){
    this.dialog.close(this.canalSelecionado);
  }
}

